
import { Name } from "./name";
import { OptionMenu } from "./option-menu";
import { States } from "../proto/states";
import { sprintf } from "sprintf-js";

const GEN_STATES = () => {
  const names = [];

  Object.keys(States).forEach(state => {
    if (state !== States.GU.id
      && state !== States.VI.id
      && state !== States.PR.id) {
      names.push(new Name(
        States[state].id,
        sprintf("%s - %s", States[state].id, States[state].label)));
    }
  });
  return names;
}

class StateOptionMenu extends OptionMenu {
  constructor(name) {
    super(name, GEN_STATES());
    this.fake = true;
  }
}

export { StateOptionMenu };
